"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FunctionalSparkle = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const FunctionalSparkle = _ref => {
  let {
    color = "#13126C",
    strokeWidth = "5",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeWidth: strokeWidth,
    d: "M16.333 4.667V14M11.667 9.333H21M9.333 42v9.333M4.667 46.667H14M32.667 9.333C32.667 19.6 26.133 28 14 28M32.667 9.333C32.667 19.6 39.2 28 51.333 28M14 28c10.267 0 18.667 6.533 18.667 18.667M51.333 28c-10.266 0-18.666 6.533-18.666 18.667"
  }));
};
exports.FunctionalSparkle = FunctionalSparkle;
FunctionalSparkle.displayName = "FunctionalSparkle";